'use client';

export function GlobalSearchBox() {
  return (
    <button type="button" id="global-search" aria-label="Menüs und Funktionen suchen" aria-haspopup="dialog"
      onClick={() => window.dispatchEvent(new CustomEvent('kontora:open-search'))}
      className="flex w-full max-w-xl items-center gap-3 rounded-[var(--k-radius-md)] border border-[var(--k-color-border-default)] bg-[var(--k-color-surface)] px-3.5 py-2.5 text-left text-sm text-[var(--k-color-text-muted)] shadow-[var(--k-shadow-xs)] transition hover:text-[var(--k-color-text-primary)] focus-visible:outline-2 focus-visible:outline-[var(--k-color-focus-ring)]">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true" className="shrink-0">
        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <span className="min-w-0 flex-1 truncate">Menüs und Funktionen suchen…</span>
      <kbd className="hidden shrink-0 rounded border border-[var(--k-color-border-subtle)] px-1.5 py-0.5 text-[10px] md:block">Strg/⌘ + /</kbd>
    </button>
  );
}
